import { DOWNLOAD_SOFTWARE } from '../constant/actionTypes';

const getDownloadSoftwareChartData = (state, action) => {
  switch (action.type) {
    case DOWNLOAD_SOFTWARE.GET.INITIATE:
      return { isFetching: false };
    case DOWNLOAD_SOFTWARE.GET.SUCCESS:
      return {
        isFetching: true,
        data: action.payload,
      };
    case DOWNLOAD_SOFTWARE.GET.ERROR:
      return action.payload;
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getDownloadSoftwareChartData;
